import React from "react";
import { PARAMETER_ID } from "../Constants";

//constant
import ic_steps from "../../../Resources/Images/ic_steps.png";
import ic_help from "../../../Resources/Images/ic_help.png";
import { Strings } from "../../../Resources/Strings/i18n";
import { SUBSCRIPTION_PLANS } from "../../../Communication/Constants";

//material UI
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

function StepsCount(props) {
  return (
    <div>
      <div className="secondAlert">
        <Accordion>
          <AccordionSummary
            expandicon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className="secondAlertHeading" component={"div"}>
              <div className="alertImg">
                <img src={ic_steps} alt="ic_steps" />
              </div>
              <div className="alertHeading">
                <div className="heading">{Strings("StepsCount")}</div>
                <div className="mobileActive">
                  {!props.stepsCountAlertData.isStepCountAlertActivated ? (
                    <p className="inActive">{Strings("Inactive")}</p>
                  ) : (
                    <p className="active">{Strings("Active")}</p>
                  )}
                </div>
                <div className="info">{Strings("StepCountAlertMessage")}</div>
              </div>
            </Typography>
            <div className="desktopActive">
              {!props.stepsCountAlertData.isStepCountAlertActivated ? (
                <p className="inActive">{Strings("Inactive")}</p>
              ) : (
                <p className="active">{Strings("Active")}</p>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <Typography className="secondAlertData" component={"div"}>
                <div className="timeNotification">
                  <div className="stepsData">
                    <div
                      className={
                        props.dailyGoalError
                          ? "stepsInput dailyGoalError"
                          : "stepsInput"
                      }
                    >
                      <TextField
                        required
                        id="standard-basic"
                        label={Strings("DayGoal")}
                        autoComplete="off"
                        disabled={
                          props.stepsCountAlertData.isStepCountAlertActivated
                        }
                        type="number"
                        value={props.stepsCountAlertData.stepCount}
                        onChange={(event) => {
                          props.dailyGoalSteps(event.target.value);
                        }}
                      />
                      <div className="hintImg">
                        <img
                          src={ic_help}
                          alt="ic_help"
                          onClick={() => {
                            props.showHintText(true);
                            setTimeout(() => {
                              props.showHintText(false);
                            }, 4000);
                          }}
                        />
                      </div>
                    </div>
                    <div className="getTime">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          expandicon={<ExpandMoreIcon />}
                          disabled={
                            props.stepsCountAlertData.isStepCountAlertActivated
                          }
                          margin="normal"
                          id="time-picker"
                          label={Strings("EndTime")}
                          value={
                            props.stepsCountAlertData.defaultFootstepsEndTime
                          }
                          onChange={(date) => {
                            props.stepsCountEndTime(date);
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change time",
                          }}
                          keyboardIcon={<AccessTimeIcon />}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>

                  <div className="notifyMeTime">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardTimePicker
                        expandicon={<ExpandMoreIcon />}
                        disabled={
                          props.stepsCountAlertData.isStepCountAlertActivated
                        }
                        margin="normal"
                        id="time-picker"
                        label={Strings("NotifyMeAt")}
                        value={
                          props.stepsCountAlertData.defaultFootstepsNotifyTime
                        }
                        onChange={(date) => props.stepsCountNotifyMeTime(date)}
                        KeyboardButtonProps={{
                          "aria-label": "change time",
                        }}
                        keyboardIcon={<AccessTimeIcon />}
                      />
                    </MuiPickersUtilsProvider>
                    <p className="careGiverAlertMessage">
                      {Strings("CaregiverAlertMessage")}
                    </p>
                  </div>
                </div>
                <div className="notifyMeHeading">{Strings("NotifyMeBy")}</div>
                <div className="phoneNotification">
                  <div className="phoneNotif">
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<RadioButtonUncheckedIcon />}
                          checkedIcon={<CheckCircleIcon />}
                          checked={
                            props.stepsCountAlertData
                              .isStepCountNotificationChecked
                          }
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label={Strings("PhoneNotification")}
                    />
                  </div>
                  <div className="textNotif">
                    <div>
                      <FormControlLabel
                        className={
                          props.stepsCountAlertData
                            .isStepCountMessageNotificationChecked
                            ? "checkedTextMessage"
                            : null
                        }
                        control={
                          <Checkbox
                            disabled={
                              props.stepsCountAlertData
                                .isStepCountAlertActivated
                            }
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            checked={
                              props.stepsCountAlertData
                                .isStepCountMessageNotificationChecked
                            }
                            onClick={() => {
                              if (props.selecteUser.id === props.userInfo.id) {
                                props.textNotificationStatus(
                                  !props.stepsCountAlertData
                                    .isStepCountMessageNotificationChecked
                                );
                              } else {
                                if (
                                  props.selecteUser !== undefined &&
                                  (props.selecteUser.subscription.product.id ==
                                    SUBSCRIPTION_PLANS.PREMIUM ||
                                  props.selecteUser.subscription.product.id ==
                                    SUBSCRIPTION_PLANS.PRO_PREMIUM)
                                ) {
                                  props.textNotificationStatus(
                                    !props.stepsCountAlertData
                                      .isStepCountMessageNotificationChecked
                                  );
                                } else {
                                  props.showInstallApp(true);
                                }
                              }
                            }}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label={Strings("TextMessage")}
                      />
                    </div>
                    {/* <div className="plan">{Strings("PREMIUM") +" / "+ Strings("PRO_PREMIUM")}</div> */}
                  </div>
                  <div className="emailNotif">
                    <div>
                      <FormControlLabel
                        className={
                          props.stepsCountAlertData
                            .isStepCountEmailNotificationChecked
                            ? "checkedTextMessage"
                            : null
                        }
                        control={
                          <Checkbox
                            disabled={
                              props.stepsCountAlertData
                                .isStepCountAlertActivated
                            }
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            checked={
                              props.stepsCountAlertData
                                .isStepCountEmailNotificationChecked
                            }
                            onClick={() => {
                              if (props.selecteUser.id === props.userInfo.id) {
                                props.emailNotificationStatus(
                                  !props.stepsCountAlertData
                                    .isStepCountEmailNotificationChecked
                                );
                              } else {
                                if (
                                  props.selecteUser !== undefined &&
                                  (props.selecteUser.subscription.product.id ==
                                    SUBSCRIPTION_PLANS.PREMIUM ||
                                  props.selecteUser.subscription.product.id ==
                                    SUBSCRIPTION_PLANS.PRO_PREMIUM)
                                ) {
                                  props.emailNotificationStatus(
                                    !props.stepsCountAlertData
                                      .isStepCountEmailNotificationChecked
                                  );
                                } else {
                                  props.showInstallApp(true);
                                }
                              }
                            }}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label={Strings("EmailPlaceHolder")}
                      />
                    </div>
                    {/* <div className="plan">{Strings("PREMIUM") +" / "+ Strings("PRO_PREMIUM")}</div> */}
                  </div>
                </div>

                {!props.stepsCountAlertData.isStepCountAlertActivated ? (
                  <div className="turnOnButton">
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={() => props.createFootStepsAlert1()}
                    >
                      {Strings("TurnOn")}
                    </Button>
                  </div>
                ) : (
                  <div className="turnOffButton">
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={() => {
                        props.deleteAlert1(
                          props.stepsCountAlertData.stepCountAlertId,
                          PARAMETER_ID.FOOTSTEPS
                        );
                      }}
                    >
                      {Strings("TurnOff")}
                    </Button>
                  </div>
                )}
              </Typography>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default StepsCount;
